<template>
    <SlideCombos :block="block" :snapAlign="'start'" :widthRate="block.platform == 1 ? 2 : 1" :is-desktop="block.platform == 1"/>
</template>
<script>
import SlideCombos from './SlideCombos';
import HomeBlock from '@/models/home-block';
export default {
    name: 'ComboBlocks',
    components:{
        SlideCombos
    },
    props:{
        block:{
            type: HomeBlock
        },
        isDesktop: {
            type: Boolean,
            default: true
        }
    }
}
</script>